import { render, staticRenderFns } from "./SyncManage.vue?vue&type=template&id=9d3b63f4&scoped=true";
import script from "./SyncManage.vue?vue&type=script&lang=js";
export * from "./SyncManage.vue?vue&type=script&lang=js";
import style0 from "./SyncManage.vue?vue&type=style&index=0&id=9d3b63f4&prod&scoped=true&lang=less";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "9d3b63f4", null);
export default component.exports;